'use strict';

import gsap from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

class PageHome {

    constructor($target) {

        //variables
        var scroll_TL
        let $components =  $target.find('.component')
        
        let heroPanel = $target.find('.component_hero')[0]
        let aboutPanel = $target.find('.component_paragraph_long')[0]
        let videoreelPanel = $target.find('.component_video_reel')[0]
        let previeLinksPanel = $target.find('.component_preview_menu')[0]
        

        let videoReelTag = document.getElementById('videoReel')
        let menuItem = document.getElementById('menu-main-menu')
        let volumenToggle = document.getElementById('volumeToggle')
        let video         = document.getElementById('videoReel')
        var volumenIconisClicked = false;

        //panel 1
        let heroPanel_title = document.querySelector(".block_hero__title")
        let logo = document.querySelector('.header__logo');
        let logoDesk = document.querySelector('.header__logo-desk');
        let menuIcon = document.querySelector('.nav-icon-wrapper');
        let blockHeroArrow = document.querySelector(".block_hero__btn-down")
        //panel 2 
        let aboutPanel_title = document.querySelector(".block_paragraph_long__title")
        let aboutPanel_bodycopy = document.querySelector(".block_paragraph_long__text")

        let showreel_label = document.querySelector(".block_paragraph_long__arrow_title")
        let showreel_arrow = document.querySelector(".block_paragraph_long__arrow")

        //panel 3
        let videoReel = document.querySelector(".component_video_reel")

        
        // panel 4
        let previewMenu = document.querySelector(".component_preview_menu")
        let previewMenuAchor = document.querySelectorAll(".block_preview_menu__anchor h3")
        let previewMenuIcon = document.querySelectorAll(".block_preview_menu__icon")
        
        let blockParagraphLongArrow = document.querySelector(".block_paragraph_long__btn-down")
        
        aboutPanel.setAttribute('id', 'about-all3media')
        
        //toggle pointer-events 
        function onPanelStart(target){
            if(target != heroPanel){
                ( scroll_TL.scrollTrigger.direction === 1) ? $(target).css("pointer-events", "auto") : $(target).css("pointer-events", "none")
            }

        }

        function onPanelEnd(target){
           ( scroll_TL.scrollTrigger.direction === 1)  ? $(target).css("pointer-events", "none") : $(target).css("pointer-events", "auto")
        }
       
        const volumeToggleEvent = () => {
            if(video.muted){
                video.muted = false
                volumenToggle.style.display = "none"
                volumenIconisClicked = true
            }else{
                video.muted = true
                volumenToggle.style.display = "block"
                volumenIconisClicked = false
            }
        }

        // show sound icon when video is playing
        const videoIsPlayingEvent = () => {
            if (video.muted && video.paused === false ) {
                volumenToggle.style.display= 'block'           
            }
        } 

        //window scroll event
        const scrollEvent = (e) => {
            //check when the size is less then 768px
            if ( WINDOW_WIDTH < window.BREAK_MD){
                //play video when viewport reaches the top of videoreel section
                if (  videoReel.getBoundingClientRect().top <= 0 ){
                    playVideoOnSCrollEvent(videoReelTag) 
                    
                }
            }
        }
        
        const goTo = (label) => {

            // scrollto section in the DOM
            function scrollTo(element) {
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: element.offsetTop
                });
            }

            //only loads if scrollTrigger has been declare
            if(scroll_TL !== undefined){

                let labelPercentagePosition = (scroll_TL.labels[label]/scroll_TL._dur)
                var scrollPos = ( ( window.innerHeight * 4)  ) * labelPercentagePosition
                gsap.to(window, { duration:0, scrollTo:scrollPos})
                
                // play video reel videoo
                if( label === "VIDEOREEL"){
                    playVideoOnSCrollEvent(videoReelTag)
                }
            }

            //trigers when page loads on mobile device 
            if(scroll_TL === undefined){
                switch (label){
                    case "ABOUT":
                        scrollTo(aboutPanel);
                        break;

                    case "VIDEOREEL":
                        scrollTo(videoreelPanel);
                        playVideoOnSCrollEvent(videoReelTag)
                        break;
                    
                }
            }

        }
        
        const eventsHandler = () =>{
            window.addEventListener("scroll",  scrollEvent )

            blockHeroArrow.addEventListener("click", () => goTo("ABOUT"))
            blockParagraphLongArrow.addEventListener("click", () => goTo("VIDEOREEL"))
            volumenToggle.addEventListener('click', volumeToggleEvent)
            video.addEventListener('playing', videoIsPlayingEvent)
            videoReelTag.addEventListener('click', volumeToggleEvent)

            menuItem.addEventListener('click', ( e ) => {
                if ( e.target.hash && e.target.hash === "#about-all3media"){
                    goTo("ABOUT")      
                }
            })
        }

        const playVideoOnSCrollEvent = (video) => {

            
            if(volumenIconisClicked === false ){
                video.play()
            }

        }

        const onVideoReelStart = () =>{ 

            if(scroll_TL.scrollTrigger.direction > 0){
                videoReelTag.play()
            }else{
                videoReelTag.pause()
            }

        }

        const onVideoReelEnd = () => {
            
            if(scroll_TL.scrollTrigger.direction < 0){
                videoReelTag.play()
            }else{
                videoReelTag.pause()
            }
        }

        const detectDesktopOnVideoReel = () => {

            //variables 

            var videoMediumScreen = window.matchMedia("(min-width:768px)");  //returns true / false
           
            //load src video 

            let videoDeskSrc = video.dataset.videoTargetDesk
             
            let videoMobSrc;
            if ( video.dataset.videoTargetMob) {
                 videoMobSrc  =video.dataset.videoTargetMob 
            }
            
            ( videoMediumScreen.matches) ? video.setAttribute("src", videoDeskSrc) : video.setAttribute("src", videoMobSrc)
                
            //remove control tag on video reel
            if ( WINDOW_WIDTH > window.BREAK_MD){
                videoReelTag.removeAttribute("controls") 
            }
        }

        function init(){

            detectDesktopOnVideoReel()
            initTimeline();
            eventsHandler()

        }


        function initTimeline() {

            ScrollTrigger.matchMedia(

                {
                    // gets trigger when window size is bigger than 768px
                    // ipad / table and desktop
                    "(min-width: 768px)": function() {

                        gsap.to(blockHeroArrow, {delay:2.5, opacity:1, duration: 0.5});
                        gsap.to(logoDesk, {delay:2.5, opacity:1, duration: 0.5});
                        gsap.to(menuIcon, {delay:2.5, opacity:1, duration: 0.5});
                        // gsap.from(heroPanel_title, {delay:3, opacity:0, y:5,  duration: 0.8});
                    
                        
                        gsap.set([aboutPanel_title, aboutPanel_bodycopy ], {opacity:0, y:80})
                        gsap.set(showreel_label, {opacity:0})
                        gsap.set(showreel_arrow, {opacity:0, y:-10})

                        // gsap.set(videoReel, {opacity:0, y:-10})

                        gsap.set(previewMenu, {y: "100%"})
                        gsap.set(previewMenuAchor, {opacity:0, y:200})
                        gsap.set(previewMenuIcon, {opacity:0,  x: - 20})
                        // gsap.from(heroPanel_title, {opacity:0, duration:1, delay:2.5})

                            scroll_TL = gsap.timeline({
                                scrollTrigger: {
                                    //markers: true,
                                    trigger: $target[0],
                                    id: "scroll_TL",
                                    toggleActions: "restart pause resume pause",
                                    pin: true,
                                    start: "top top",
                                    end: "400%",
                                    scrub: 1
                              }
                            });
    
                            //panel 2 
                            scroll_TL.call(onPanelStart, [heroPanel])
                            scroll_TL.to(heroPanel, {duration:1, opacity:0 })
                            scroll_TL.call(onPanelEnd, [heroPanel],"-=0.3")
                            scroll_TL.call(onPanelStart, [aboutPanel],"-=0.3")
                            scroll_TL.to([aboutPanel_title, aboutPanel_bodycopy ], {delay:-0.3, duration:0.8, opacity:1, y:0, stagger:0.08})
                            scroll_TL.to(showreel_label, {delay: -0.25, duration:0.5, opacity:1})
                            scroll_TL.to(showreel_arrow, {delay: -0.5, duration:1, opacity:1, y:0})
                           
                            scroll_TL.addLabel("ABOUT", "-=0.5")

                            //panel 3
                            scroll_TL.to([aboutPanel_bodycopy, aboutPanel_title, showreel_arrow, showreel_label], { delay: -0.5, duration:1, opacity: 0 })
                            scroll_TL.to([aboutPanel], {duration:0.5, opacity: 0 })


                            //panel 4 
                           
                            scroll_TL.addLabel("VIDEOREEL");
                            scroll_TL.call(onVideoReelStart, [] ,"-=0.5")
                            
                            scroll_TL.call(onPanelEnd, [aboutPanel], "-=0.5")
                            scroll_TL.call(onPanelStart, [previewMenu],"-=0.5")
                            
                            scroll_TL.to(previewMenu, {delay:0, duration:1, y:"0%"})
                            scroll_TL.to(videoReel, {delay:-1, duration:1, y:"-50%"})
                            scroll_TL.call(onVideoReelEnd, [])

                            scroll_TL.to(previewMenuAchor, {delay: - 1,   duration:0.5, opacity:1, y:0, stagger:0.3})
                            scroll_TL.to(previewMenuIcon, {delay: -0.3,   duration:0.5, opacity:1, y:0, x:0,  stagger:0.2})


                            scroll_TL.to(videoreelPanel, {opacity: 0})
                            scroll_TL.addLabel("PREVIEWLINKS")
                            
                            if(window.location.hash == "#about-all3media"){
                                let labelPercentagePosition = (scroll_TL.labels.ABOUT/scroll_TL._dur)
                                var scrollPos = ( ( window.innerHeight * 4)  ) * labelPercentagePosition
                                gsap.to(window, { duration:0, scrollTo:scrollPos})
                            }
            
                    },
                    //mobile
                    "(max-width: 767px)": function() {
                        
                        gsap.set(logoDesk, {opacity:0});
                        gsap.set([aboutPanel_title, aboutPanel_bodycopy ], {opacity:1})
                        gsap.set(showreel_label, {opacity:1})
                        gsap.set(showreel_arrow, {opacity:1})
                        gsap.set(previewMenu, {y: "0%"})
                        // gsap.set(heroPanel_title, {opacity:1})

                        gsap.set(previewMenuAchor, {opacity:1, y:0})
                        gsap.set(previewMenuIcon, { opacity:1, x:0})
                    }

                }

            )

        }
        

      
      

        init();

        return {

        }

    }

}
    
export default PageHome;